"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  '-2': '-2px',
  '-4': '-4px',
  '-8': '-8px',
  '-12': '-12px',
  '-16': '-16px',
  '-20': '-20px',
  '-24': '-24px',
  '-32': '-32px',
  '-40': '-40px',
  '-42': '-42px',
  '-48': '-48px',
  '-70': '-70px',
  '-140': '-140px',
  '0': '0',
  '2': '2px',
  '4': '4px',
  '6': '6px',
  '8': '8px',
  '12': '12px',
  '16': '16px',
  '20': '20px',
  '24': '24px',
  '32': '32px',
  '40': '40px',
  '42': '42px',
  '48': '48px',
  '52': '52px',
  '56': '56px',
  '64': '64px',
  '70': '70px',
  '80': '80px',
  '140': '140px'
};
//# sourceMappingURL=spacing.js.map